import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import PersonInput from "../common/personInput";
import AddressInput from "../common/addressInput";
import NaturalPersonViewModel from "../../../../viewModels/notice/components/operator/naturalPersonViewModel";
import { registerView } from "@frui.ts/views";

const NaturalPersonView: FunctionComponent<{
  vm: NaturalPersonViewModel;
}> = observer(({ vm }) => (
  <>
    <PersonInput
      vm={vm}
      fullNamePredicate={vm.person.validateFullName}
      birthDatePredicate={vm.person.validateBirthDate}
      showBirthdate={vm.showBirthdate}
    />
    <AddressInput vm={vm} />
  </>
));

registerView(NaturalPersonView, NaturalPersonViewModel);
